import { Fragment } from "react/jsx-runtime";

import { EReputationMatchResult } from "src/core/types/entity";

type NotesSectionProps = {
  selectedMatch: EReputationMatchResult;
};

export const NotesSection = ({ selectedMatch }: NotesSectionProps) => {
  if (!selectedMatch?.detail?.notes?.length) {
    return null;
  }

  return (
    <div className="flex flex-col mt-6 mx-10">
      <div className="font-light">
        {selectedMatch?.detail?.notes
          .join("\n")
          .split("\n\n") // on découpe d'abord sur les doubles retours
          .map((paragraph, idx) => (
            <p key={idx} className="mb-2">
              {paragraph.split("\n").map((line, lineIdx) => (
                <Fragment key={`note-paragraph-${lineIdx}`}>
                  {line}
                  <br />
                </Fragment>
              ))}
            </p>
          ))}
      </div>
    </div>
  );
};
